"use client";
import { jsx as _jsx } from "react/jsx-runtime";
// import hooks
import { useState } from "react";
import { Provider } from "./Environment.context.js";
export const EnvironmentProviderComponent = ({ children, userId: userIdProp, tenantId: tenantIdProp, ...ctxValue }) => {
    const [userId, setUserId] = useState(userIdProp);
    const [tenantId, setTenantId] = useState(tenantIdProp);
    return _jsx(Provider, { value: { userId, tenantId, setUserId, setTenantId, ...ctxValue }, children: children });
};
export default EnvironmentProviderComponent;
